import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import type { ButtonProps } from '@mui/material/Button';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import type { IMenuItem } from '@uipath/portal-shell/dist/types/components/ap-menu/ap-menu.react';
import { ApMenu } from '@uipath/portal-shell-react';
import React, { useMemo } from 'react';

interface IUiDropdownButtonProps extends ButtonProps {
    tooltip?: string;
    disabled?: boolean;
    onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
    label: string;
    menuItems: IUiDropdownButtonMenuItemProps[];
}

interface IUiDropdownButtonMenuItemProps {
    label: string;
    onClick?: () => void;
    dataCy?: string;
}

export const UiDropdownButton: React.FC<IUiDropdownButtonProps> = ({
    tooltip,
    disabled,
    onClick,
    label,
    menuItems,
    ...props
}) => {
    const [ menuAnchorEl, setMenuAnchorEl ] = React.useState<undefined | HTMLElement>(undefined);

    const transformedMenuItems: IMenuItem[] = useMemo(() => menuItems.map((item) => ({
        onClick: () => {
            setMenuAnchorEl(undefined);
            item.onClick?.();
        },
        title: item.label,
        variant: 'item' as const,
    })), [ menuItems ]);

    return (
        <>
            <Tooltip
                arrow
                title={tooltip ?? ''}>
                <span>
                    <Button
                        disabled={disabled}
                        onClick={
                            onClick ?? (event => {
                                event.stopPropagation();
                                setMenuAnchorEl(event.currentTarget);
                            })
                        }
                        variant="contained"
                        data-testid="dropdown-btn-primary-action-button"
                        data-cy="dropdown-btn-primary-action-button"
                        endIcon={<KeyboardArrowDownIcon />}
                        {...props}
                    >
                        {label}
                    </Button>
                </span>
            </Tooltip>
            <ApMenu
                menuItems={transformedMenuItems}
                isOpen={!!menuAnchorEl}
                anchorEl={menuAnchorEl}
                onMenuClose={(_event) => {
                    setMenuAnchorEl(undefined);
                }}
            />
        </>
    );
};
